import { getRequest, postRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";

export const ADVERTISEMENT_ANALYTICS_DATALIST =
  "ADVERTISEMENT_ANALYTICS_DATALIST";
export const ADVERTISEMENT_CLICKANALYTICS_DATALIST =
  "ADVERTISEMENT_CLICKANALYTICS_DATALIST";
export const ADVERTISEMENT_ANALYTICS_COUNT =
  "ADVERTISEMENT_ANALYTICS_COUNT";

 export function fetchadvertisementanalyticCounts (session, callback) {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=advertisementanalyticCounts&eventid=${session.eventid}`;
  return (dispatch) => {
    postRequest(
      url,
        {
          type: "advertisementanalyticCounts",
          eventid: session.eventid,
        },
      session,
      dispatch,
      (response) => {
        var data = response;
        //Prepare data for Device Installs..
        dispatch({
          type: ADVERTISEMENT_ANALYTICS_COUNT,
          payload: { data: data },
        });
        callback({
          error: 0,
          data: "Analytics, Number of bookmarked exhibitors profiles !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};


export function fetchadvertisementviewanalytics (session, callback) {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=advertisementviewanalyticsData&eventid=${session.eventid}`;
  return (dispatch) => {
    postRequest(
      url,
        {
          type: "advertisementviewanalyticsData",
          eventid: session.eventid,
        },
      session,
      dispatch,
      (response) => {
        var data = response.data;
        //Prepare data for Device Installs..
        dispatch({
          type: ADVERTISEMENT_ANALYTICS_DATALIST,
          payload: { data: data },
        });
        callback({
          error: 0,
          data: "Analytics, Number of bookmarked exhibitors profiles !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export function fetchadvertisementclickanalytics (session, callback) {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=advertisementclicksanalyticsData&eventid=${session.eventid}`;
  return (dispatch) => {
    postRequest(
      url,
        {
          type: "advertisementclicksanalyticsData",
          eventid: session.eventid,
        },
      session,
      dispatch,
      (response) => {
        var data = response.data;
        //Prepare data for Device Installs..
        dispatch({
          type: ADVERTISEMENT_CLICKANALYTICS_DATALIST,
          payload: { data: data },
        });
        callback({
          error: 0,
          data: "Analytics, Number of bookmarked exhibitors profiles !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};
